@let corporateDesign = corporateDesignService.corporateDesign();
@let texts = textStore.texts();
@if (corporateDesign && !configurationStore.isLoading()) {
  <div
    class="border-standard-outline-light flex items-center border-b-1 font-medium"
    [attr.data-testid]="'account-page-headline-container'"
    [style.font-size]="corporateDesign.fontSizeTitle | toFontSize"
    [style.background-color]="
      corporateDesignService.isDarkModeActive()
        ? corporateDesign.colorAdmixtures.dark_background
        : ''
    "
    [style.color]="corporateDesignService.fontColor()">
    <h1
      class="container mx-auto flex flex-row justify-center px-4 py-4 md:justify-start md:px-0"
      [attr.data-testid]="'private-area-headline'">
      {{
        texts
          | filterTexts: RelationType.privateAreaLabel : EEntityType.privateArea
          | language
      }}
    </h1>
    <aw-burger-menu class="md:hidden" [menuContent]="sideMenu"></aw-burger-menu>
  </div>
  <div
    class="container mx-auto flex flex-col gap-2 px-4 pt-4 md:flex-row md:gap-4 md:px-0">
    <div class="hidden w-full flex-col md:flex md:w-1/3">
      <ng-container *ngTemplateOutlet="sideMenu"></ng-container>
    </div>
    <div class="pb-8 md:w-2/3" [attr.data-testid]="'private-area-content'">
      @if (!preview) {
        <router-outlet></router-outlet>
      }
    </div>
  </div>

  <ng-template #sideMenu>
    <div
      class="flex w-full flex-col gap-4 md:gap-2"
      [attr.data-testid]="'private-area-side-nav'">
      <aw-side-section-navigation
        (onSelect)="burgerMenu.closeMenu()"
        [style]="{
          backgroundColor: corporateDesignService.isDarkModeActive()
            ? corporateDesign.colorAdmixtures.dark_surface_01
            : '',
        }"
        id="account-navigation-account"
        [icon]="
          configurationStore.getStringConfiguration(
            CONFIGURATION_SETTING_KEYS.AccountIcon
          )
        "
        [title]="
          texts
            | filterTexts: RelationType.accountName : EEntityType.privateArea
            | language
        "
        [links]="[
          {
            label:
              texts
              | filterTexts: RelationType.userInfo : EEntityType.privateArea
              | language,
            url: 'info',
          },
          {
            label:
              texts
              | filterTexts
                : RelationType.deleteAccountLabel
                : EEntityType.privateArea
              | language,
            url: 'delete',
          },
        ]"></aw-side-section-navigation>
      @if (
        configurationStore.getBooleanConfiguration(
          CONFIGURATION_SETTING_KEYS.IsSubscriptionActive
        ) ||
        (configurationStore.getBooleanConfiguration(
          CONFIGURATION_SETTING_KEYS.IsDirectSaleActive
        ) &&
          configurationStore.getEnumConfiguration(
            CONFIGURATION_SETTING_KEYS.PaymentProvider,
            EPaymentProviders
          ) === EPaymentProviders.Logpay)
      ) {
        <aw-side-section-navigation
          (onSelect)="burgerMenu.closeMenu()"
          id="account-navigation-payment"
          [icon]="
            configurationStore.getStringConfiguration(
              CONFIGURATION_SETTING_KEYS.PaymentIcon
            )
          "
          [title]="
            texts
              | filterTexts
                : RelationType.paymentInfoLabel
                : EEntityType.privateArea
              | language
          "
          titleLink="/account/payment"></aw-side-section-navigation>
      }

      <aw-side-section-navigation
        (onSelect)="burgerMenu.closeMenu()"
        id="account-navigation-past-orders"
        icon="nest_clock_farsight_analog"
        title="Vergangene Bestellungen"
        titleLink="/account/orders"></aw-side-section-navigation>
      <aw-side-section-navigation
        (onSelect)="burgerMenu.closeMenu()"
        id="account-navigation-subscriptions"
        icon="calendar_month"
        title="Abonnements"
        [links]="[]"></aw-side-section-navigation>
      @if (fellowTravelerStore.isActive()) {
        <aw-side-section-navigation
          (onSelect)="burgerMenu.closeMenu()"
          id="account-fellow-travelers"
          icon="groups"
          [title]="
            texts
              | filterTexts
                : RelationType.fellowTravelersLabel
                : EEntityType.privateArea
              | language
          "
          titleLink="/account/fellow-travelers">
        </aw-side-section-navigation>
      }

      <aw-side-section-navigation
        (onSelect)="burgerMenu.closeMenu()"
        id="account-navigation-documents"
        icon="lab_profile"
        title="Dokumente"
        titleLink="/account/documents"></aw-side-section-navigation>
    </div>
  </ng-template>
}
